<template>
  <a-modal
    :visible="visible"
    title="添加好友"
    @cancel="handleCancel"
    @ok="handleAddFriend"
    width="500px"
    okText="添加"
    cancelText="取消"
  >
    <!-- 步骤1：输入手机号 -->
    <div   class="form-container">
       
      <a-form layout="vertical">
        <a-form-item label="TG号码">
          <a-input
            v-model:value="phoneNumber"
            placeholder="请输入TG账号"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSendTelegramSearch">
            查找
          </a-button>
        </a-form-item>
      </a-form>
 
    </div>

    <div class="targets-list">
      <a-checkbox-group
        v-model:value="taskForm.targetIds"
        class="targets-checkbox-group"
      >
        <a-checkbox
          v-for="target in targetIdsList"
          :key="target.userId"
          :value="target.userName"
          class="target-item"
        >
          <div class="target-info">
            <span class="target-name">{{ target.userName }}</span>
            <span class="target-nickname" v-if="target.userId">
              ({{ target.userId }})
            </span>
          </div>
        </a-checkbox>
      </a-checkbox-group>
    </div>

 
  </a-modal>
</template>

<script lang="ts" setup>
import { ref,onMounted,onUnmounted, reactive, defineProps, defineEmits } from "vue";
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";
import { useStore } from 'vuex';
const client = TelegramClient.getInstance();
const store = useStore();
const phoneNumber = ref("");
interface UserInfo {
	   userId:number;	// 用户ID 聊天唯一ID
     phone:string;	// 手机号
     userName:string;	// 用户名
     userNick:string;	// 用户昵称
     isContact:boolean;	// 是否为联系人
}

const targetIdsList = ref<UserInfo[]>([]);

 


// 表单相关
const taskForm = ref<{
  targetIds: string[];
}>({
  targetIds: [],
});

const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
  (e: "success"): void;
}>();

 

// 发送验证码
const handleSendTelegramSearch = async () => {
    if(phoneNumber.value == "")
    {
      message.error(`发送失败: TG账号不能为空`);
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendTelegramSearch(
      account,
      name,
      phoneNumber.value
    );
    if(result.message&&result.message.user_info)
    {
      targetIdsList.value.push(result.message.user_info);
    }
    console.log("handleSendTelegramSearch");

};

onMounted(() => {
  //phoneNumber.value = "fda";
  //targetIdsList.value = [{name:"123",nickname:"123"},{name:"121",nickname:"121"}]
  targetIdsList.value = [];
  console.log("AddFriend onMounted");
});

onUnmounted(() => {

  console.log("AddFriend onUnmounted");

});


const handleCancel = () => {
  console.log("handleCancel");
  emit("update:visible", false);
  targetIdsList.value = [];
  phoneNumber.value = "";
};


const handleAddFriend = async() => {
  console.log("handleAddFriend");
  var targetIds =  taskForm.value.targetIds;
  if(targetIds.length == 0)
  {
    message.error(`发送失败:好友不能为空`);
    return
  }
  var chatIds:any[] = [];
  for (let i = 0; i < targetIds.length; i++) {
    const element1 = targetIds[i];
      for (let ii = 0; ii < targetIdsList.value.length; ii++) {
      const element2 = targetIdsList.value[i];
      if(element1 == element2.userName)
      {
        chatIds.push({userId:element2.userId,userNick:element2.userNick});
      }
    }
  }
  
  const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    const result = await client.sendTelegramAddUser(
      account,
      name,
      chatIds[0].userNick,
      chatIds[0].userId,
    );
    if(result.message&&result.message.code == 1)
    {
      message.info(result.message.msg);
      phoneNumber.value = "";
      targetIdsList.value = [];
    }
    else if(result.message)
    {
      message.error(result.message.msg);
    }


};


 
</script>

<style scoped>
.form-container {
  outline: none;
  padding: 10px;
}

.target-item {
  margin: 0;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.targets-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
.targets-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

</style>
